var map = {
	"./10_camp.jpg": 93983,
	"./2_5_camp.jpg": 81287,
	"./4_3_camp.jpg": 89939,
	"./5_camp.jpg": 36611,
	"./Camp.jpg": 28779,
	"./camp-1.jpg": 70290,
	"./camp-2.jpg": 68116,
	"./camp-4.png": 25668,
	"./camp-banner.jpg": 95454,
	"./camp-new-1.png": 36859,
	"./camp-new-2.png": 42438,
	"./camp-school.jpeg": 28308,
	"./camp_11.jpg": 27386,
	"./camp_13.jpg": 70887,
	"./camp_14.jpg": 49253,
	"./camp_15.jpg": 74457,
	"./camp_16.jpg": 20382,
	"./camp_17.jpg": 14611,
	"./camp_18.jpg": 39771,
	"./camp_5.jpeg": 41425,
	"./camp_5.jpg": 41172,
	"./camp_6.jpg": 2593,
	"./cmap_12.jpg": 39830,
	"./fertility-camp.png": 32196,
	"./health-check-upp.jpg": 9681,
	"./health-checkup-camp-ramanagara.jpg": 40918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27810;